"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.getUrlBase = function (url) {
  return url.substring(0, url.indexOf('?'));
};

exports.hasOneWord = function (string) {
  return typeof string === 'string' && string.indexOf(' ') === -1;
};

exports.concatMessages = function (messages) {
  return typeof messages === 'string' ? messages : messages.length > 1 ? messages.join('-') : messages[0];
};

exports.multilineEllipsis = function (string, maxString) {
  var newString = string.slice(0, maxString);
  return string.length <= maxString ? string : "".concat(newString.trim(), "...");
};

exports.stringCompare = function (string, stringToCompare) {
  return string.toUpperCase() === stringToCompare.toUpperCase();
};

exports.addSign = function (sign) {
  return function (value) {
    if (!value) return value;
    return "".concat(sign).concat(value);
  };
};

exports.toCamel = function (string) {
  return string.replace(/([-_][a-z])/gi, function ($1) {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};

var STRING_UTILS = {
  getUrlBase: exports.getUrlBase,
  hasOneWord: exports.hasOneWord,
  concatMessages: exports.concatMessages,
  multilineEllipsis: exports.multilineEllipsis,
  stringCompare: exports.stringCompare,
  addSign: exports.addSign,
  toCamel: exports.toCamel
};
exports.default = STRING_UTILS;